import { createRouter, createWebHistory } from 'vue-router';
import MainRoutes from './MainRoutes';
import AuthRoutes from './AuthRoutes';
import { useAuthStore } from '@/stores/auth';

export const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/:pathMatch(.*)*',
            component: () => import('@/views/authentication/Error.vue')
        },
        MainRoutes,
        AuthRoutes
    ]
});

router.beforeEach(async (to, from, next) => {
    const publicPages = [
        '/auth/login2',
        '/auth/new-password',
        '/auth/reset-confirm'
    ];
    const authRequired = !publicPages.includes(to.path);
    const auth = useAuthStore();

    if (authRequired && !auth.isAuthenticated) {
        auth.returnUrl = to.fullPath;
        auth.logout();  // clears expired session
        return next('/auth/login2');
    }

    if (auth.isAuthenticated) {
        auth.refreshTokenExpiry();  // 👈 Reset the session timer
    }

    return next();
});
